import React from "react";
import "./Profeature.scss";
import { useHistory } from "react-router";
import Modal from "react-bootstrap/Modal";
function Profeature({
  showDownloadPdfPopup,
  setShowDownloadPdfPopup,
  handleToggle,
  id,
}) {
  const history = useHistory();
  const handleHide = () => {
    setShowDownloadPdfPopup(false);
    history.push(`/resumes/${id}`);
  };
  function getCookie(key) {
    var b = document.cookie.match("(^|;)\\s*" + key + "\\s*=\\s*([^;]+)");
    return b ? b.pop() : "";
  }
  const handleDownloadPdf = () => {
    const pdfName = getCookie("samplepdf");
    if (pdfName && pdfName != "") {
      const pdfUrl = `https://assets.qwikresume.com/resume-samples/pdf/${pdfName}`;
      window.open(pdfUrl, "_blank", "noopener,noreferrer");
    }
  };
  return (
    <>
      <Modal
        // {...props}
        show={showDownloadPdfPopup}
        backdrop="static"
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="profeature-modal"
      >
        <Modal.Body>
          <img
            onClick={handleHide}
            src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/close.svg`}
            alt="closeicon"
            className="close"
          />
          <div className="">
            <div className="d-flex justify-content-between">
              <div className="profeature-left-image">
                {/* <img
                  src="/images/profeature.png"
                  alt="profeature"
                  className="popupimage"
                /> */}
              </div>

              <div className="px-3">
                <div className="">
                  <>
                    <h4 className="header-feature mb-3">
                      Customize Your Resume
                    </h4>
                    <p className="sub-text-feature mb-4">
                      Thank you for choosing to download one of our sample
                      resumes! To help you get the most out of our editor and
                      premium templates, we've loaded the content from your
                      selected resume into our resume editor page.
                    </p>
                    {""}
                    <p>
                      Here, you can edit the content to fit your own skills and
                      experience, or use our premium templates to create a
                      brand-new resume from scratch.
                    </p>
                  </>
                </div>
                <div className="d-flex mt-3">
                  <button
                    className="btn primarybtn bgsuccess text-white p-2  mr-5"
                    onClick={handleHide}
                  >
                    Try Our Editor
                  </button>
                  <button
                    className="btn outline-secondary  p-2 "
                    onClick={handleDownloadPdf}
                  >
                    Download Resume
                  </button>
                </div>
                {/* <div className="col-md-12">
                  <button
                    className="btn primarybtn bgsuccess text-white p-14 w-100"
                    onClick={handlePayment}
                  >
                    Explore Pro Features
                  </button>
                </div> */}
              </div>
            </div>

            {/* {props && props.hideEditing ? (
              <div className="row justify-content-center">
                <div className="col-md-6">
                  <button
                    className="btn primarybtn bgsuccess text-white p-14 w-100"
                    onClick={handlePayment}
                  >
                    Explore Pro Features
                  </button>
                </div>
              </div>
            ) : (
              <div className="row">
                <div className="col-md-6">
                  <button
                    className="btn primarybtn float-right w-75 mainborder"
                    onClick={props.onHide}
                  >
                    Continue Editing
                  </button>
                </div>
                <div className="col-md-6">
                  <button
                    className="btn primarybtn bgsuccess text-white p-14 w-75"
                    onClick={handlePayment}
                  >
                    Explore Pro Features
                  </button>
                </div>
              </div>
            )} */}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Profeature;
